export const buildInfo: { gitHash: string; dateTime: number | 'local' } = { gitHash: '0b11308', dateTime: 1775852396032 };